import { render, staticRenderFns } from "./chatbot-page.vue?vue&type=template&id=f5731e84&scoped=true&"
import script from "./chatbot-page.vue?vue&type=script&lang=js&"
export * from "./chatbot-page.vue?vue&type=script&lang=js&"
import style0 from "./chatbot-page.vue?vue&type=style&index=0&id=f5731e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5731e84",
  null
  
)

export default component.exports